<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>

    <br />
    <b-button variant="primary" v-if="loading" disabled>
      <b-spinner small></b-spinner>
      Cargando...
    </b-button>

    <div class="mt-2 col-md-12"></div>
    <p
      v-show="presupuesto.length == 0 && loading == false"
      class="mginTop15 boldBlue size22"
    >
      No se encontraron presupuestos para el paciente.
    </p>

    <div v-show="presupuesto.length != 0" class="presupuestos">
      <div
        v-for="item in presupuesto"
        :key="item.idSesion"
        :value="item.nombreClinica"
      >
        <div class="divPresupuesto">
          <b-button
            :class="item.visible ? null : 'collapsed'"
            :aria-expanded="item.visible ? 'true' : 'false'"
            @click="item.visible = !item.visible"
            id="text-button"
            variant="primary"
          >
            <b-icon icon="caret-up-fill" v-if="item.visible"></b-icon>
            <b-icon icon="caret-down-fill" v-else></b-icon>
            {{ item.nombreClinica }} - {{ item.fecha }}
          </b-button>
          <b-collapse v-model="item.visible" class="mt-2">
            <b-card>
              <span v-if="item.opciones.length != 0">
                <span
                  v-for="(opcion, index) in item.opciones"
                  :key="index"
                  :value="index"
                >
                  <p class="boldBlue size18">
                    <span> Opción {{ opcion.opcion }} </span>
                    <br />
                    <br />

                    <b-badge
                      variant="success"
                      class="trtPadecimiento"
                      v-if="opcion.opcionAceptada == 'SI'"
                      >Opción aceptada</b-badge
                    >
                    <b-badge
                      variant="warning"
                      class="trtPadecimiento"
                      v-if="opcion.opcionAceptada == 'NO'"
                      >Opción no aceptada</b-badge
                    >
                    <br />
                    <br />
                  </p>
                  <p class="txtDoctor">
                    <span class="boldTxt">Odontólogo: </span>
                    <span>{{ opcion.empleadoNombre }}</span>
                  </p>

                  <br />

                  <b-table
                    hover
                    :items="opcion.tratamientos"
                    :fields="titulos"
                    head-variant="light"
                    v-if="opcion.tratamientos.length != 0"
                    :ref="item.idSesion"
                    selectable
                    :select-mode="selectMode"
                    @row-selected="
                      (items) => onRowSelected(item.idSesion, items)
                    "
                  >
                    <template v-slot:cell(precio)="row">
                      {{ row.item.precio | moneda }}
                    </template>

                    <template v-slot:cell(noDiente)="row">
                      <span v-if="row.item.noDiente != 0">
                        {{ row.item.noDiente }}
                      </span>
                      <span v-else> N/A </span>
                    </template>

                    <template v-slot:cell(descuento)="row">
                      <span> {{ row.item.descuento }} % </span>
                    </template>

                    <template v-slot:cell(ahorro)="row">
                      <span> {{ row.item.ahorro | moneda }} </span>
                    </template>

                    <template v-slot:cell(precioTotal)="row">
                      <span> {{ row.item.precioTotal | moneda }} </span>
                    </template>

                    <template v-slot:cell(tratamientoProgramado)="row">
                      <span v-if="row.item.tratamientoProgramado == true">
                        <b-badge variant="success"
                          ><b-icon icon="check-square" font-scale="1.5"></b-icon
                        ></b-badge>
                      </span>
                      <span v-else>
                        <b-badge variant="warning"
                          ><b-icon icon="x-square" font-scale="1.5"></b-icon
                        ></b-badge>
                      </span>
                    </template>

                    <template v-slot:cell(tratamientoActivo)="row">
                      <span v-if="row.item.tratamientoActivo == true">SI</span>
                      <span v-else>NO</span>
                    </template>
                  </b-table>

                  <div class="flxButton">
                    <b-button
                      variant="outline-primary"
                      @click="$refs[item.idSesion][index].selectAllRows()"
                      class="btnEstilo"
                    >
                      Seleccionar todo
                    </b-button>
                    <br />
                    <b-button
                      variant="outline-danger"
                      @click="$refs[item.idSesion][index].clearSelected()"
                      class="btnEstilo"
                    >
                      Limpiar selección
                    </b-button>
                    <br />
                    <b-button
                      variant="info"
                      @click="aProgramados(item.idSesion, item, opcion.opcion)"
                      class="btnEstilo"
                      v-if="!banderaBtn"
                      :disabled="banderaBtn == true"
                    >
                      Pasar a programados
                      <b-icon
                        icon="arrow-right-circle"
                        animation="cylon"
                        style="margin-left: 5px"
                      ></b-icon>
                    </b-button>
                    <b-button v-else variant="info" class="btnEstilo" disabled>
                      <b-spinner small></b-spinner>
                      Cargando...
                    </b-button>
                  </div>

                  <br />
                  <span class="badgeCss" v-if="opcion.grantotal != 0">
                    <b-badge
                      variant="primary"
                      class="trtPadecimiento"
                      align="left"
                    >
                      Total global {{ opcion.grantotal | moneda }}</b-badge
                    >
                  </span>

                  <br />

                  <p
                    v-if="opcion.tratamientos.length == 0"
                    class="mginTop15 boldBlue"
                    style="text-align: left"
                  >
                    No se encontraron tratamientos
                  </p>
                </span>
              </span>
            </b-card>
          </b-collapse>
        </div>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>
<script>
import moment from "moment";
import _ from "lodash";
import miniToastr from "mini-toastr";

export default {
  name: "Presupuesto",
  components: {},
  props: {
    idPaciente: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    planSeleccionado: null,
    selectMode: "multi",
    selected: [],
    presupuesto: [],
    loading: true,
    banderaBtn: false,
    titulos: [
      {
        key: "etapa",
        label: "Etp",
        sortable: true,
      },
      {
        key: "noDiente",
        label: "OD",
        sortable: true,
      },
      {
        key: "numSesiones",
        label: "Cantidad",
        sortable: true,
      },
      {
        key: "tratamientoNombre",
        label: "Tratamiento",
        sortable: true,
      },
      {
        key: "precio",
        label: "Precio unitario",
        sortable: true,
      },
      {
        key: "descuento",
        label: "Descuento unitario",
        sortable: true,
      },
      {
        key: "ahorro",
        label: "Ahorro",
        sortable: true,
      },
      {
        key: "precioTotal",
        label: "Precio total unitario",
        sortable: true,
      },
      {
        key: "tratamientoProgramado",
        label: "Programado",
        sortable: true,
      },
      {
        key: "tratamientoActivo",
        label: "Tratamiento Activo",
        sortable: true,
      },
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.getPresupuestos();
  },
  methods: {
    aProgramados(id, datos, opcion) {
      var banderaOpcionAceptada = false;

      datos.opciones.forEach((element) => {
        if (element.opcion != opcion) {
          element.tratamientos.forEach((trt) => {
            if (trt.tratamientoProgramado == true) {
              banderaOpcionAceptada = true;
            }
          });
        }
      });

      if (this.selected[id] == undefined || this.selected[id].length == 0) {
        miniToastr.warn("Selecciona mínimo un tratamiento por presupuesto");
      } else {
        var banderaProgramados = false;

        var listaTratamientos = "  ";

        this.selected[id].forEach((trt, index) => {
          listaTratamientos += trt.tratamientoNombre.toLowerCase();
          if (trt.tratamientoProgramado) {
            banderaProgramados = true;
          }

          if (index != [this.selected[id].length - 1]) {
            listaTratamientos += ", ";
          }
        });

        if (banderaProgramados || banderaOpcionAceptada) {
          var txt =
            banderaProgramados == true
              ? "Hay tratamientos que ya son programados, se reinició la lista"
              : "Ya fue programado un tratamiento de otra opción, se reinició la lista";

          miniToastr.warn(txt);

          this.selected[id].forEach((element) => {
            if (element.tratamientoProgramado) {
              this.$refs[id][0].clearSelected();
            }
          });

          this.selected[id] = [];
        } else {
          var banderaDos = false;

          this.selected[id].forEach((trt) => {
            if (!trt.tratamientoActivo) {
              banderaDos = true;
              miniToastr.warn(
                "El tratamiento: " +
                  trt.tratamientoNombre.toLowerCase() +
                  " se encuentra inactivo."
              );
              this.$refs[id][0].clearSelected();
            }
          });

          if (!banderaDos) {
            this.selected[id].forEach((element) => {
              element.idPlanTratamiento = this.planSeleccionado;
            });

            //Los tratamientos se generaran con precio actual?

            this.$swal
              .fire({
                title:
                  "<strong>¿Desea actualizar los precios de los tratamientos?</strong>",
                icon: "error",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                allowOutsideClick: false
              })
              .then(() => {
                this.$swal
                  .fire({
                    title: "¿Desea actualizar los precios de los tratamientos?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    allowOutsideClick: false
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      this.$swal
                        .fire({
                          title:
                            "¿Estás seguro de pasar a programados estos tratamientos? " +
                            listaTratamientos,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonText: "Aceptar",
                          cancelButtonText: "Cancelar",
                          showLoaderOnConfirm: true,
                          inputPlaceholder: "Posible réplica forzoza",
                          input: "checkbox",
                          inputValue: 0,
                        })
                        .then((result) => {
                          if (result.isConfirmed) {
                            this.banderaBtn = true;
                            this.$http
                              .put(
                                this.$api +
                                  "diagnostico/presupuestos/programados?idUsuario=" +
                                  this.$localStorageService.getIdUsuario() +
                                  "&idClinica=" +
                                  this.$localStorageService.getIdClinica() +
                                  "&replica=" +
                                  result.value +
                                  "&idEmpleado=" +
                                  this.$localStorageService.getIdEmpleado() +
                                  "&precioActual=true",
                                {
                                  listaTrts: this.selected[id],
                                }
                              )
                              .then(() => {
                                this.$swal({
                                  icon: "success",
                                  title: "Se ingresó correctamente",
                                  showConfirmButton: false,
                                  timer: 2500,
                                  onClose: () => {},
                                });
                                miniToastr.success(
                                  "Se guardo correctamente el registro"
                                );
                              })
                              .catch((error) => {
                                this.banderaBtn = false;
                                this.$swal.fire({
                                  icon: "error",
                                  title: "Oops...",
                                  text: error.response.data.message,
                                });
                              })
                              .finally(() => {
                                this.selected[id] = [];
                                this.$refs[id][0].clearSelected();
                                this.getPresupuestos();
                              });
                          }
                        });
                    } else {
                      this.$swal
                        .fire({
                          title:
                            "¿Estás seguro de pasar a programados estos tratamientos? " +
                            listaTratamientos,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonText: "Aceptar",
                          cancelButtonText: "Cancelar",
                          showLoaderOnConfirm: true,
                          inputPlaceholder: "Posible réplica forzoza",
                          input: "checkbox",
                          inputValue: 0,
                        })
                        .then((result) => {
                          if (result.isConfirmed) {
                            this.banderaBtn = true;
                            this.$http
                              .put(
                                this.$api +
                                  "diagnostico/presupuestos/programados?idUsuario=" +
                                  this.$localStorageService.getIdUsuario() +
                                  "&idClinica=" +
                                  this.$localStorageService.getIdClinica() +
                                  "&replica=" +
                                  result.value +
                                  "&idEmpleado=" +
                                  this.$localStorageService.getIdEmpleado() +
                                  "&precioActual=false",
                                {
                                  listaTrts: this.selected[id],
                                }
                              )
                              .then(() => {
                                this.$swal({
                                  icon: "success",
                                  title: "Se ingresó correctamente",
                                  showConfirmButton: false,
                                  timer: 2500,
                                  onClose: () => {},
                                });
                                miniToastr.success(
                                  "Se guardo correctamente el registro"
                                );
                              })
                              .catch((error) => {
                                this.banderaBtn = false;
                                this.$swal.fire({
                                  icon: "error",
                                  title: "Oops...",
                                  text: error.response.data.message,
                                });
                              })
                              .finally(() => {
                                this.selected[id] = [];
                                this.$refs[id][0].clearSelected();
                                this.getPresupuestos();
                              });
                          }
                        });
                    }
                  });
              });
          }
        }
      }
    },
    onRowSelected(tableKey, items) {
      this.selected[tableKey] = items;
    },
    getPresupuestos() {
      const parametros = {idPaciente: this.idPaciente}
      this.$http
        .post(
          this.$api +
            "diagnostico/presupuestos/paciente", parametros
        )
        .then((response) => {
          var datos = JSON.parse(JSON.stringify(response.data.data));
          if (Array.isArray(datos)) {
            this.presupuesto = _(datos)
              .groupBy(
                ({ idSesion, idTratamiento, opcion, idDiente }) =>
                  idSesion + idTratamiento + opcion + idDiente
              )
              .map((g) =>
                _.mergeWith(...g, (o, s, k) =>
                  k === "numSesiones" ? o + s : o
                )
              )
              .value();

            this.presupuesto = _.chain(this.presupuesto)
              .groupBy("idSesion")
              .map((value, key) => ({
                idSesion: key,
                nombreClinica: value[0]["clinicaNombre"],
                fecha: moment(value[0]["fecha"]).utc().format("DD/MM/YYYY"),
                visible: false,
                opciones: _.chain(value)
                  .groupBy("opcion")
                  .map((valueD, keyD) => ({
                    empleadoNombre: valueD[0]["empleadoNombre"],
                    opcionAceptada: valueD[0]["opcionAceptada"],
                    opcion: keyD,
                    tratamientos: valueD,
                  }))
                  .value(),
              }))
              .value();

            this.presupuesto.forEach((element) => {
              element.opciones.forEach((elementOpt) => {
                elementOpt.grantotal = 0;
                elementOpt.tratamientos.forEach((trt) => {
                  elementOpt.grantotal += trt.precioTotal * trt.numSesiones;
                });
              });
            });
            // ? ORDENAR LOS PRESUPUESTOS POR ID
            this.presupuesto = _.orderBy(
              this.presupuesto,
              ["idSesion"],
              ["desc"]
            );
          }
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        })
        .finally(() => {
          this.banderaBtn = false;
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.alignLeft {
  width: 100%;
  text-align: left;
}

.presupuestos {
  min-height: 200px;
}

.divPresupuesto {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 10px;
}

#text-button {
  text-align: left;
}

.trtPadecimiento {
  padding: 10px;
  font-size: 15px;
  letter-spacing: 1px;
  font-weight: lighter;
}

.badgeCss {
  display: flex;
  justify-content: flex-end;
}

.txtDoctor {
  color: black;
  text-align: left;
  margin-bottom: -10px;
}

.boldTxt {
  font-weight: bolder;
}

.flxButton {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
}

.btnEstilo {
  width: 250px;
}
</style>
